import { useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/user-assignment/UserAssignmentAction";
import { getAuthorities, resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../_metronic/_partials/controls";
import { useParentUsersUIContext } from "./ParentUsersUIContext";
import { ParentUsersFilter } from "./parent-users-filter/ParentUsersFilter";
import { ParentUsersTable } from "./parent-users-table/ParentUsersTable";

export function ParentUsersCard({
  history,
  userGroupId,
  userType
}) {
  // Parent Users Card UI Context
  const parentUsersUIContext = useParentUsersUIContext();
  const parentUsersUIProps = useMemo(() => {
    return {
      ids: parentUsersUIContext.ids
    };
  }, [parentUsersUIContext]);

  // Getting curret state of UserAssignment from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.userAssignment }),
    shallowEqual
  );  
  const { entities, authorities } = currentState;

  // Authority Parameters
  const { isEditionAuthorized } = getAuthorities(authorities);

  // Parent Users Redux state
  const dispatch = useDispatch();

  // Belli Bir Kullanıcı Grubuna Ait Kullanıcı Listesini Kaydeder
  const saveUsers = (ids) => {
    const selectedEntities = entities.filter(entity => ids.includes(entity.id));
    const userIds = [...new Set(selectedEntities.map(entity => entity.userId))];
    dispatch(actions.saveUsers(userType, userGroupId, userIds)).then(result => onResult(result));
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/kullanici-ve-kullanici-gruplari/${userType}`), 2500);
  };

  const title = <>Veli Kullanıcı Listesi{parentUsersUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{parentUsersUIProps.ids.length}</span>]</> :
                   ""}
                </>;

  return (
    <Card>
      <CardHeader title={title}>
        {
          isEditionAuthorized &&
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => saveUsers(parentUsersUIProps.ids)}
            >
              Kaydet
            </button>
          </CardHeaderToolbar>
        }
      </CardHeader>
      <CardBody>
        <ParentUsersFilter />
        <ParentUsersTable />
      </CardBody>
    </Card>
  );
}